import React from 'react';
import { motion } from 'framer-motion';
import { EnvelopeIcon, GlobeAltIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const InvSlide17ThankYou: React.FC = () => {
  const highlights = [
    { label: 'Market', value: '4.1M students' },
    { label: 'Modules', value: '680 tracked' },
    { label: 'Cost', value: '$2-3/student' },
    { label: 'Margin', value: '~95%' },
    { label: 'LTV', value: '13 years' },
    { label: 'Status', value: 'Trial ready' },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="relative inline-block mb-6">
          <span
            className="absolute inset-0 text-7xl md:text-8xl font-black text-[#06b6d4] blur-xl opacity-50"
            aria-hidden="true"
          >
            Lumen8
          </span>
          <span className="relative text-7xl md:text-8xl font-black bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] bg-clip-text text-transparent">
            Lumen8
          </span>
        </span>
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-3xl text-[#94a3b8] font-light mb-8"
      >
        Thank You
      </motion.h2>

      {/* Key Highlights */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        className="flex flex-wrap justify-center gap-6 mb-10 max-w-4xl"
      >
        {highlights.map((item) => (
          <div
            key={item.label}
            className="px-5 py-3 rounded-xl"
            style={{
              background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
          >
            <div className="text-2xl font-bold text-[#0ea5e9]">{item.value}</div>
            <div className="text-sm text-[#64748b]">{item.label}</div>
          </div>
        ))}
      </motion.div>

      {/* Contact */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        className="flex items-center gap-8"
      >
        <a
          href="mailto:hello@lumen8.it"
          className="flex items-center gap-2 px-6 py-3 rounded-xl transition-all hover:scale-105"
          style={{
            background: 'rgba(14, 165, 233, 0.2)',
            border: '1px solid rgba(14, 165, 233, 0.4)',
          }}
        >
          <EnvelopeIcon className="w-5 h-5 text-[#0ea5e9]" />
          <span className="text-white">hello@lumen8.it</span>
        </a>

        <a
          href="https://lumen8.it"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-6 py-3 rounded-xl transition-all hover:scale-105"
          style={{
            background: 'rgba(16, 185, 129, 0.2)',
            border: '1px solid rgba(16, 185, 129, 0.4)',
          }}
        >
          <GlobeAltIcon className="w-5 h-5 text-[#10b981]" />
          <span className="text-white">lumen8.it</span>
          <ArrowTopRightOnSquareIcon className="w-4 h-4 text-[#10b981]" />
        </a>
      </motion.div>

      {/* Tagline */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.9 }}
        className="mt-12"
      >
        <p className="text-xl text-[#64748b] italic">
          "Duolingo meets the Australian curriculum, with teachers and parents in the loop."
        </p>
      </motion.div>

      {/* Q&A prompt */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.1 }}
        className="mt-8 px-6 py-3 rounded-full"
        style={{
          background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.15) 0%, rgba(6, 182, 212, 0.15) 100%)',
          border: '1px solid rgba(14, 165, 233, 0.3)',
        }}
      >
        <p className="text-[#94a3b8]">
          Questions? Let's discuss.
        </p>
      </motion.div>
    </div>
  );
};

export default InvSlide17ThankYou;
